module.exports = __webpack_public_path__ + "img/2024nh2.c0bf2847.jpg";